import { apiRequest } from '@common/api/utils';
import {
  apiUrl,
  perPage,
  callbackMap,
  REFERRAL_STATS_TABS,
} from '@referrals/utils/constants';


const BASE_URL = apiUrl;

const REFERRAL_URL = {
  applied: `${BASE_URL}/load-applied-data/`,
  enrolled: `${BASE_URL}/load-referral-data/`,
  referred: `${BASE_URL}/fetch-referrals/`,
  appliedSst: `${BASE_URL}/load-referral-data/`,
  appliedSsb: `${BASE_URL}/load-referral-data/`,
  sstTestStatus: `${BASE_URL}/load-referral-data/`,
};

function loadReferral(filters) {
  const params = {
    product: filters.product,
    page_number: filters.pageNumber,
    per_page: perPage,
    referrals_search: filters.referee_name,
    referee_status: filters.referee_status,
    reward_statuses: filters.reward_status,
    current_region: filters.current_region,
    sst_filter: filters.referralState === REFERRAL_STATS_TABS.sstTestStatus.key,
  };

  const url = REFERRAL_URL[filters.referralState];
  return apiRequest('POST', url, params);
}

function referUser(details) {
  const url = `${BASE_URL}/refer/`;
  return apiRequest('POST', url, { ...details });
}

function requestCallback(key, remarks) {
  const url = `${BASE_URL}/request-callback/`;
  return apiRequest('POST', url, { callback_type: callbackMap[key], remarks });
}

function requestCallbackWithToken(token) {
  return apiRequest('POST', `${BASE_URL}/request-callback/?token=${token}`);
}

function behaviouralData(eventType, eventData = null) {
  const url = `${BASE_URL}/track-activity/`;
  return apiRequest('POST', url,
    { activity_name: eventType, activity_data: eventData });
}

function referralStats() {
  const url = `${BASE_URL}/referral-stats/`;
  return apiRequest('GET', url);
}

export default {
  loadReferral,
  referUser,
  requestCallback,
  behaviouralData,
  requestCallbackWithToken,
  referralStats,
};
